export const border = '0.0625rem solid rgba(0, 0, 0, 1)'
